module.exports = __webpack_public_path__ + "static/fonts/355CC9_0_0.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/355CC9_0_0.eot
// module id = 8
// module chunks = 0